import { useEffect, useState } from "react";

export function useMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    function windowResize() {
      // Mobile cutoff is ≤1199px to match @krea/shared/hooks/useMobile, the
      // shared Sidebar, and the `xl` breakpoint (min-width:1200 = desktop).
      if (window.matchMedia("(max-width: 1199px)").matches) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }

    windowResize();

    window.addEventListener("resize", windowResize);

    return () => {
      window.removeEventListener("resize", windowResize);
    };
  }, []);

  return isMobile;
}
